// Libraries
import React from 'react';

// App
import ProjectWidgetKind from '@shared/modules/Project/enums/ProjectWidgetKind';
import SalesPageContent from '@shared/modules/Sales/components/SalesPageContent';
import SidebarPageV2 from 'modules/App/components/SidebarPageV2';

const SalesPage = () => {
  return (
    <SidebarPageV2 selected={'sales'}>
      <SalesPageContent
        projectPaneWidgets={[
          // TODO: Update for full office app content
          ProjectWidgetKind.PROJECT_DETAILS,
          ProjectWidgetKind.CONVERSATIONS,
          ProjectWidgetKind.COMMENTS,
          ProjectWidgetKind.EVENT_LOG,
        ]}
      />
    </SidebarPageV2>
  );
};

export default SalesPage;
